import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'exceptFilterPipe', standalone: true })
export class ExceptFilterPipe implements PipeTransform {
  transform(items: any[], exceptItems: any[], property?: string): any[] {
    if (!items || !exceptItems) {
      return items;
    }
    return items.filter(item =>
      exceptItems.every(exceptItem =>
        property ? exceptItem[property] !== item[property] : exceptItem !== item
      )
    );
  }
}
